// src/AppWrapper.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AppWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const root = document.getElementById("root");
    const pathClass = location.pathname
      .replace(/\//g, "-")
      .replace(/^-|-$/g, "") || "home";

    root.className = `page-${pathClass}`;
  }, [location]);

  return children;
};

export default AppWrapper;
